import { DaoModel } from '@dynameat/models';

export class AssociatedProduct extends DaoModel {
  constructor(productIndexingGuid, associatedProductGuid, ratio) {
    super(productIndexingGuid);
    this.productIndexingGuid = productIndexingGuid;
    this.associatedProductGuid = associatedProductGuid;
    this.ratio = ratio;
  }

  static toInstance(props = {}) {
    return new AssociatedProduct(props.product_indexing_guid, props.associated_product_guid, props.ratio);
  }
}
